<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->

<template>
  <div class="positions-text">
    <Shield :county="data.fid" :municipality="data.kid" :title="data.name" />
    <div class="positions-text__text">
      <strong>{{ data.name }}</strong> er nummer <strong>{{ data.countyPosition }}</strong> av {{ data.countyCount }} kommuner i fylket og nummer <strong>{{ data.countryPosition }}</strong> av alle landets {{ data.municipalityCount }} kommuner.
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";
@import "../assets/mixins";

.positions-text {
  display: flex;
  margin-bottom: 2em;
  justify-content: flex-start;

  .shield {
    padding-top: 0.25em;
  }

  &__text {
    font-size: 150%;
    padding-left: 0.5em;
    line-height: 1.4;
  }
}
</style>

<script>
import Shield from './Shield.vue'

export default {
  props: {
    data: Object
  },

  components: {
    Shield
  },

  computed: {

  }
}
</script>
